import React from 'react';
import ReactLoading from 'react-loading';
import ReactModal from 'react-modal';
import styles from './index.module.scss';

ReactModal.setAppElement('#root');

const modalStyles = {
  content: {
    border: 'none',
    bottom: 'unset',
    left: '0.3rem',
    overflow: 'visible',
    padding: 0,
    right: '0.3rem',
    top: '2.1rem'
  },
  overlay: {
    backgroundColor: 'rgba(0, 0, 0, 0.8)'
  }
};

export function Modal(props: ReactModal.Props & { children: React.ReactNode }) {
  return <ReactModal style={modalStyles} {...props} />;
}

const loadingStyles = {
  content: {
    background: 'transparent',
    border: 'none',
    bottom: 'unset',
    left: '50%',
    overflow: 'visible',
    padding: 0,
    right: 'unset',
    top: '40%',
    transform: 'translateX(-50%)'
  },
  overlay: {
    backgroundColor: 'transparent',
    zIndex: 9
  }
};

export function Loading(props: ReactModal.Props) {
  return (
    <ReactModal style={loadingStyles} {...props}>
      <ReactLoading
        className={styles.loading}
        type="spin"
        height=".6rem"
        width=".6rem"
        color="#000"
      />
    </ReactModal>
  );
}

const toastStyles = {
  content: {
    border: 'none',
    bottom: 'unset',
    left: '50%',
    overflow: 'visible',
    padding: 0,
    right: 'unset',
    top: '40%',
    transform: 'translateX(-50%)'
  },
  overlay: {
    backgroundColor: 'transparent',
    pointerEvents: 'none',
    zIndex: 9
  }
};

export function Toast(props: ReactModal.Props & { message: string }) {
  const { message, ...restProps } = props;

  return (
    <ReactModal style={toastStyles} {...restProps}>
      <div className={styles.toast}>{message}</div>
    </ReactModal>
  );
}
